/* TF · Fútbol · Reels — reproducción silenciosa, playsinline, carga diferida,
 * reproduce solo lo visible (IntersectionObserver). Respeta reduced-motion. */
(function () {
  'use strict';
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

  function load(v) {
    if (v.__tfLoaded) return; v.__tfLoaded = true;
    v.querySelectorAll('source[data-src]').forEach(function (s) {
      if (!s.getAttribute('src')) s.setAttribute('src', s.getAttribute('data-src'));
    });
    v.load();
  }

  function init(root) {
    var vids = (root || document).querySelectorAll('[data-tf-freel-video]');
    if (!vids.length) return;
    if (!('IntersectionObserver' in window)) { vids.forEach(load); return; }
    var io = new IntersectionObserver(function (ents) {
      ents.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) {
          load(v);
          if (!reduce) { var p = v.play(); if (p && p.then) p.then(function () { v.classList.add('is-playing'); }).catch(function () {}); }
        } else {
          v.pause(); v.classList.remove('is-playing');
        }
      });
    }, { rootMargin: '0px 0px 8% 0px', threshold: 0.35 });
    vids.forEach(function (v) { io.observe(v); });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', function () { init(); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
